module.exports = __webpack_public_path__ + "static/ChristinaWang-c39cbc8ccd107c11768de293993d8cf3.png";